export default class Tabs {
    readonly element: JQuery<HTMLElement>;
    readonly items: JQuery<HTMLElement>;

    public currentTab: JQuery<HTMLElement>;
    public onTabChange: (tab: JQuery<HTMLElement>) => void;

    public constructor(target: JQuery<HTMLElement>) {
        this.element = $(target);
        this.items = this.element.find('.tabs__item');
        this.element.find('.tabs__link').on('click', this.onChange);
        this.currentTab = this.element.find('.tabs__item.is-active .tabs__link');
    }

    protected onChange = (event: JQuery.TriggeredEvent): void => {
        event.preventDefault();
        const tab: JQuery<HTMLElement> = $(event.currentTarget);

        this.currentTab = tab;
        if (!tab.parent('.tabs__item').hasClass('is-active')) {
            this.items.removeClass('is-active');
            tab.parent('.tabs__item').addClass('is-active');
            if (this.onTabChange) {
                this.onTabChange(tab);
            }
        }
    }
}
